import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Icons/Close.png'
import _imports_1 from '@/assets/images/Icons/ForgotError.png'
import _imports_2 from '@/assets/images/ErrorMete.png'
import _imports_3 from '@/assets/images/Mete/Mete.png'


const _withScopeId = n => (_pushScopeId("data-v-dfb053fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "forgot_error icon"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "license_mete",
  src: _imports_3,
  alt: "License-메테"
}

import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalTemplate',
  props: {
    transitionName: {},
    isModalOpen: { type: Boolean },
    errorTitle: {},
    isErrorMeteIcon: { type: Boolean },
    isLicenceMeteIcon: { type: Boolean }
  },
  setup(__props: any) {

const { showModal, closeModal } = useCommonStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: _ctx.transitionName }, {
    default: _withCtx(() => [
      (_ctx.isModalOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["modal_panel", {license_panel : _unref(showModal).isLicense}])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "modal_panel_close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeModal) && _unref(closeModal)(...args)))
            }, _hoisted_2),
            _createElementVNode("h6", null, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.errorTitle), 1)
            ]),
            (_ctx.isErrorMeteIcon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: _normalizeClass(["error_mete", {forgotModal : _unref(showModal).isForgotAccount}]),
                  src: _imports_2,
                  alt: "ERROR-메테"
                }, null, 2))
              : _createCommentVNode("", true),
            (_ctx.isLicenceMeteIcon)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["modal_description", { successModal : !_ctx.isErrorMeteIcon, forgotModal : _unref(showModal).isForgotAccount }])
            }, [
              _renderSlot(_ctx.$slots, "contentDescription")
            ], 2),
            _renderSlot(_ctx.$slots, "contact")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["name"]))
}
}

})